export default __webpack_public_path__ + "static/media/blue-umbrella.2d36f97a.png";